import React, { Component } from 'react';

class Navigation extends Component {

  componentDidMount() {
    $('#side-menu').metisMenu();
  }

  render() {
    return (
      <nav className="navbar-default navbar-static-side" role="navigation">
        <div className="slimScrollDiv">
          <div className="sidebar-collapse">
            {
              this.props.children ?
              <ul className="nav metismenu" id="side-menu" ref="menu">
                {this.props.children}
              </ul> :
              this.props.navItems
            }
          </div>
        </div>
      </nav>
    );
  }
}

export default Navigation;
